import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { ADDED_PRODUCT_POPUP_ID } from 'Component/AddToCartPopUp/AddToCartPopUp.config';
import { CHECKOUT_URL } from 'Route/Checkout/Checkout.config';
import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';
import { closePopup } from 'Store/Popup/Popup.action';
import { ProductType } from 'Type/ProductList.type';
import history from 'Util/History';
import { appendWithStoreCode } from 'Util/Url';

import AddToCartPopUp from './AddToCartPopUp.component';
/** @namespace Bodypwa/Component/AddToCartPopUp/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    originalProduct: state.ProductReducer ? state.ProductReducer.product : null
});

/** @namespace Bodypwa/Component/AddToCartPopUp/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    closePopup: (payload) => dispatch(closePopup(ADDED_PRODUCT_POPUP_ID, payload)),
    hideActiveOverlay: () => dispatch(hideActiveOverlay())
});

/** @namespace Bodypwa/Component/AddToCartPopUp/Container */
export class AddToCartPopUpContainer extends PureComponent {
    static propTypes = {
        product: ProductType.isRequired,
        originalProduct: ProductType.isRequired,
        closePopup: PropTypes.func.isRequired,
        hideActiveOverlay: PropTypes.func.isRequired,
        image: PropTypes.shape({
            url: PropTypes.string,
            path: PropTypes.string
        }).isRequired,
        isAdding: PropTypes.bool.isRequired
    };

    containerFunctions = {
        goToCheckout: this.goToCheckout.bind(this),
        continueShopping: this.continueShopping.bind(this)
    };

    state = {
        redirect: false
    };

    componentDidUpdate() {
        const { redirect } = this.state;
        if (redirect) {
            this.setState({ redirect: false });
            history.push({
                pathname: appendWithStoreCode(CHECKOUT_URL)
            });
        }
    }

    containerProps() {
        const { product, originalProduct } = this.props;

        return {
            product,
            originalProduct
        };
    }

    goToCheckout() {
        const { hideActiveOverlay } = this.props;
        hideActiveOverlay();
        this.setState({ redirect: true });
    }

    continueShopping() {
        const { hideActiveOverlay } = this.props;
        hideActiveOverlay();
    }

    render() {
        return (
            <AddToCartPopUp
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToCartPopUpContainer);
